import axios from 'axios';
import { config } from './../Constants';

const instance = axios.create({
    baseURL: config.url.BASE_URL
});

let axiosConfig = {
    headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        "Access-Control-Allow-Origin": "*",
    }
  };

export const get = (apiUrl, params, successFunc, errorFunc, finallFunc, raw = false) => {
    return instance.get(apiUrl, raw ? params : { params })
    .then(successFunc)
    .catch(errorFunc)
    .then(finallFunc);
}

export const post = (apiUrl, params, successFunc, errorFunc, finallFunc, raw = false) => {
    return instance.post(apiUrl, raw ? params : { params }, axiosConfig)
    .then(successFunc)
    .catch(errorFunc)
    .then(finallFunc);
}